import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import TableList from '@/components/TableList/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import copyCommonDialog from '@/views/butler/creative-direction/copyCommonDialog';
import previewModal from '@/components/PreviewModal';
import { myTemplatePreview, getPsTemplate } from '@ps/api/project';

export default {
  components: {
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination,
    copyCommonDialog: copyCommonDialog,
    previewModal: previewModal
    // IndustryCategoryCascader
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      listLoading: true,
      // 请求参数
      query: {
        page: 1,
        page_size: 15,
        id: '',
        name: '',
        adv_id: ''
      },
      pagination: {
        total: 0
      },
      // 表单数据
      list: [],
      copyDialog: {
        visible: false
      },
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        showCnUrl: false,
        id: ''
      },
      previewLoading: '',
      templateInfo: {},
      industryList: [],
      playMethodList: []
    };
  },


  watch: {
    $route: function $route(to, from) {
      this.getTemplateList(this.query);
    }
  },

  computed: {
    // 搜索栏配置
    formItemList: function formItemList() {
      return [{
        type: 'input',
        prop: 'id',
        params: {
          clearable: true,
          placeholder: '请输入模板ID'
        }
      }, {
        type: 'input',
        prop: 'keyword',
        params: {
          clearable: true,
          placeholder: '请输入模板名称'
        }
      }, {
        prop: 'adv_id',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          clearable: true,
          style: 'width: 220px;',
          class: 'search-filter-select'
        }
      }];
    },

    // 表格配置
    tableColumnConfig: function tableColumnConfig() {
      // const self = this
      return [{
        label: '模板ID',
        prop: 'id',
        width: 120,
        align: 'center'
      }, {
        slot: 'name-cell'
      }, {
        slot: 'thumbnail-cell'
      }, {
        label: '广告主',
        prop: 'adv_name',
        align: 'center'
      }, {
        label: '使用次数',
        prop: 'use_times',
        sortable: true,
        width: 120,
        align: 'center'
      }, {
        slot: 'updated-time-cell'
      }, {
        slot: 'action-cell'
      }];
    }
  },

  methods: {
    previewTemplate: function previewTemplate(obj) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.previewLoading = obj.id;
                _context.prev = 1;
                _context.next = 4;
                return myTemplatePreview({
                  id: obj.project_id
                });

              case 4:
                res = _context.sent;

                _this.previewLoading = '';
                if (res.code === 0) {
                  _this.previewDialog.visible = true;
                  _this.previewDialog.title = obj.name;
                  _this.previewDialog.html_url = _.get(res, 'data.preview_url');
                } else {
                  _this.$message.error(res.msg);
                }
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                _this.previewLoading = '';
                _this.$message.error(_context.t0.message);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    getTemplateList: function getTemplateList(params) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.listLoading = true;
                _context2.next = 3;
                return getPsTemplate(params);

              case 3:
                res = _context2.sent;

                _this2.listLoading = false;
                _this2.list = (_.get(res, 'data.list') || []).map(function (item) {
                  return _extends({}, item, {
                    name_en: item.name,
                    industry_categories_name: [],
                    play_methods_name: []
                  });
                });
                _this2.pagination.total = _.get(res, 'data.total');

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleCopy: function handleCopy(item) {
      this.showTemplateDialog(item);
    },
    showTemplateDialog: function showTemplateDialog(item) {
      this.copyDialog.visible = true;
      var data = _.pick(item, ['id', 'name', 'name_en', 'estimate_time', 'thumbnail']);
      this.templateInfo = _extends({}, data, {
        source: 'ps',
        src_template_id: data.id || '',
        src_template_name: '',
        thumbnail_l: data.thumbnail
      });
    },
    timeSort: function timeSort(a, b) {
      return a.updated_time - b.updated_time;
    },
    toCommonTemplate: function toCommonTemplate(id, skins) {
      var skinId = _.get(skins, ['0', 'id']);
      if (!skinId) {
        this.$message.error('该模板缺少皮肤');
        return;
      }
      this.$router.push({
        name: 'creative.common-template',
        params: {
          templateId: id,
          skinId: skinId
        }
      });
    },
    handleCreateSuccess: function handleCreateSuccess() {
      this.getTemplateList(this.query);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.$store.dispatch('config/getGmakerConfig');

            case 2:
              res = _context3.sent;

              _this3.industryList = (_.get(res, 'industry_categories') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];
              _this3.playMethodList = (_.get(res, 'play_methods') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              }) || [];
              _this3.materialCategory = (_.get(res, 'material_categories') || []).map(function (item) {
                return _extends({}, item, {
                  label: item.name,
                  value: item.id
                });
              });
              _this3.getTemplateList(_this3.query);

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
};